import React, { Component, lazy, Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./stylesheets/App.less";
import Loading from "./components/common/IndefiniteLoader";
import "bootstrap/dist/css/bootstrap.min.css";
import { createBrowserHistory } from "history";
import Sidebar from "./containers/sidebar";
const history = createBrowserHistory();
const GlobalRoute = lazy(() =>
    import(/* webpackChunkName: "GlobalRoute" */ "./routes/global")
);
const AuthRoute = lazy(() =>
    import(/*webpackChunkName "AuthRoute"*/ "./routes/auth")
);
class App extends Component {
    componentDidMount() {
        const { loadUser } = this.props;
        loadUser();
    }

    render() {
        const { isAuthenticated } = this.props;

        return (
            <Router history={history}>
                <Sidebar />
                <Suspense fallback={<Loading className={"wp100 mt20"} />}>
                    {isAuthenticated === true && (
                        <AuthRoute history={history} />
                    )}
                    {isAuthenticated === false && <GlobalRoute />}
                </Suspense>
            </Router>
        );
    }
}

export default App;
